const IconeTV = '/images/svg/icone-tv.svg'
const IconeConsorcio = '/images/svg/icone-consorcio.svg'
const IconeSeguros = '/images/svg/icon-seguros.svg'
const IconeCredito = '/images/svg/icone-credito.svg'
const IconeAtacado = '/images/svg/icone-atacado.svg'
const TV = `${process.env.INTERNAL_IMAGES_URL}/images/png/tv-gazin.png`
const Consorcio = `${process.env.INTERNAL_IMAGES_URL}/images/jpg/consorcio.jpg`
const Seguros = `${process.env.INTERNAL_IMAGES_URL}/images/jpg/img-seguros.jpg`
const Creditos = `${process.env.INTERNAL_IMAGES_URL}/images/jpg/credito.jpg`
const Atacado = `${process.env.INTERNAL_IMAGES_URL}/images/jpg/atacado.jpg`

import Image from 'next/image'
import * as S from './styles'
import { useBlackFriday } from '../../contexto/hooks/useBlackFriday'

export type ItemServicoProps = {
  imagem: string
  icone: string
  nome: string
  descricao: string
  url: string
}

export type SetorServicosProps = {
  darkTheme: boolean
}

const ItemServico = ({
  imagem,
  icone,
  nome,
  descricao,
  url,
}: ItemServicoProps) => {
  const { isBlackFridayTheme } = useBlackFriday()

  return (
    <S.ServicesLink href={url} target="_blank" rel="noopener noreferrer">
      <S.ServicesImage>
        <Image src={imagem} alt={nome} fill sizes="25rem" />
      </S.ServicesImage>
      <S.ServicesInfo darkTheme={isBlackFridayTheme}>
        <S.ServicesIcone>
          <Image
            src={icone}
            alt={nome}
            width={40}
            height={40}
            className="image-icon-services"
          />
        </S.ServicesIcone>
        <S.ServicesSubText>
          <h3>{nome}</h3>
          <p>{descricao}</p>
        </S.ServicesSubText>
      </S.ServicesInfo>
    </S.ServicesLink>
  )
}

export default function SetorServicos({ darkTheme }: SetorServicosProps) {
  return (
    <S.ServicesSection darkTheme={darkTheme}>
      <S.ServicesReponsive>
        <S.ServicesContainer>
          <S.ServicesText>
            <h2>Gazin tem muito mais</h2>
            <S.ServicesSubTitle>
              Nós queremos estar com você em todos os momentos especiais da sua
              vida. Conheça nossos outros serviços.
            </S.ServicesSubTitle>
            <ItemServico
              imagem={TV}
              icone={IconeTV}
              nome="TV Gazin"
              descricao="De A a Z, conectada com você."
              url="https://tvgazin.com.br/"
            />
          </S.ServicesText>
          <ItemServico
            imagem={Consorcio}
            icone={IconeConsorcio}
            nome="Consórcios"
            descricao="Trabalhando para que grandes sonhos se tornem realidade."
            url="https://consorciogazin.com.br/"
          />
          <ItemServico
            imagem={Seguros}
            icone={IconeSeguros}
            nome="Seguros"
            descricao="Uma seguradora voltada para demandas  de móveis e eletrodomésticos."
            url="https://www.gazinseguros.com.br/"
          />
          <ItemServico
            imagem={Creditos}
            icone={IconeCredito}
            nome="Crédito"
            descricao="Créditos concedidos através de produtos financeiros."
            url="https://www.gazinbank.com.br/"
          />
          <ItemServico
            imagem={Atacado}
            icone={IconeAtacado}
            nome="Atacado"
            descricao="Produtos em atacado com descontos inacreditáveis."
            url="https://www.gazinatacado.com.br/"
          />
        </S.ServicesContainer>
      </S.ServicesReponsive>
    </S.ServicesSection>
  )
}
